// extracted by mini-css-extract-plugin
module.exports = {"GroupInput":"_3UKCcKb9UI8fWIbOF0o16E"};